import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FornecedorInserirComponent } from './fornecedor-inserir.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: FornecedorInserirComponent }
    ])],
    exports: [RouterModule]
})
export class FornecedorInserirRoutingModule { }
